import { PropTypes } from 'prop-types'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { CardContent, CardFooter } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'

const schema = yup.object().shape({
  username: yup.string().required('Username is required'),
  fullName: yup.string().required('Full name is required'),
  email: yup.string().email('Invalid email address').required('Email is required'),
  newPassword: yup
    .string()
    .nullable()
    .notRequired()
    .test('min-if-present', 'Password must be at least 8 characters long', (value) => !value || value.length >= 8),
  retypePassword: yup
    .string()
    .nullable()
    .notRequired()
    .oneOf([yup.ref('newPassword')], 'Passwords must match'),
})

const UserDetailsForm = ({ user }) => {
  const onSubmit = (data) => {
    console.log('Form Data:', data)
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      username: user.username,
      fullName: user.fullName,
      email: user.email,
      newPassword: '',
      retypePassword: '',
    },
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CardContent className="space-y-6">
        <Separator />
        <div className="grid grid-cols-4 gap-4">
          <Label htmlFor="username" className="col-span-1 self-center">
            Username
          </Label>
          <div className="col-span-2">
            <Input
              disabled={true}
              id="username"
              placeholder="Enter your username"
              className="col-span-2"
              {...register('username')}
            />
            {errors.username && <p className="text-orange-500 text-sm">{errors.username.message}</p>}
          </div>
        </div>
        <Separator />
        <div className="grid grid-cols-4 gap-4">
          <Label htmlFor="fullName" className="col-span-1 self-center">
            Full Name
          </Label>
          <div className="col-span-2">
            <Input disabled={true} id="fullName" placeholder="Enter your full name" {...register('fullName')} />
            {errors.fullName && <p className="text-orange-500 text-sm">{errors.fullName.message}</p>}
          </div>
        </div>
        <Separator />
        <div className="grid grid-cols-4 gap-4">
          <Label htmlFor="email" className="col-span-1 self-center">
            E-mail
          </Label>
          <div className="col-span-2">
            <Input disabled={true} id="email" type="email" placeholder="Enter your email" {...register('email')} />
            {errors.email && <p className="text-orange-500 text-sm">{errors.email.message}</p>}
          </div>
        </div>
        <Separator />
        <div className="grid grid-cols-4 gap-4">
          <Label className="col-span-1 self-center">Avatar</Label>
          <div className="flex items-center space-x-4 col-span-2">
            <Avatar className="w-24 h-24 col-span-1">
              <AvatarImage src={user.avatarUrl} alt="User avatar" />
              <AvatarFallback>{user.initials}</AvatarFallback>
            </Avatar>
          </div>
          <div className="col-span-1 inline-flex justify-start">
            <Button variant="secondary" size="sm" className="m-auto border-0 bg-transparent col-span-1 font-bold">
              Delete
            </Button>
            <Button
              as="label"
              htmlFor="avatar"
              variant="secondary"
              size="sm"
              className="m-auto flex items-center justify-center border-0  bg-transparent col-span-1  font-bold text-primary"
            >
              Update
              <Input id="avatar" type="file" accept="image/*" className="hidden" />
            </Button>
          </div>
        </div>
        <Separator />
        <div className="grid grid-cols-4 gap-4">
          <Label htmlFor="newPassword" className="col-span-1 self-center">
            New Password
          </Label>
          <div className="col-span-2">
            <Input
              disabled={true}
              id="newPassword"
              type="password"
              placeholder="Enter new password"
              {...register('newPassword')}
            />
            {errors.newPassword && <p className="text-orange-500 text-sm">{errors.newPassword.message}</p>}
          </div>
        </div>
        <div className="grid grid-cols-4 gap-4">
          <Label htmlFor="retypePassword" className="col-span-1 self-center">
            Retype New Password
          </Label>
          <div className="col-span-2">
            <Input
              disabled={true}
              id="retypePassword"
              type="password"
              placeholder="Retype new password"
              {...register('retypePassword')}
            />
            {errors.retypePassword && <p className="text-orange-500 text-sm">{errors.retypePassword.message}</p>}
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex justify-end space-x-4">
        <Button variant="secondary" className="" type="button" onClick={() => reset()}>
          Cancel
        </Button>
        <Button className="" type="submit" disabled={true}>
          Save
        </Button>
      </CardFooter>
    </form>
  )
}
UserDetailsForm.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    fullName: PropTypes.string,
    username: PropTypes.string,
    initials: PropTypes.string,
  }).isRequired,
}

export default UserDetailsForm
